import { useMemo, useState } from "react";
import { streamItems } from "@/mocks/home";

const filters = ["全部", "实拍", "直击", "录制", "围观"] as const;

export default function StreamTimeline() {
  const [activeFilter, setActiveFilter] = useState<(typeof filters)[number]>("全部");

  const visibleItems = useMemo(() => {
    if (activeFilter === "全部") return streamItems;
    return streamItems.filter((item) => item.tag === activeFilter);
  }, [activeFilter]);

  return (
    <section id="stream" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-[11px] tracking-[0.32em] text-secondary-500">快讯流</span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新的现场更新时间线
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              按更新时间从新到旧排列，每一段都标好了是实拍、直击还是录制，快速翻到最新现场更新。
            </p>
          </div>

          <div className="inline-flex flex-wrap gap-1 self-start rounded-full border border-background-300 bg-background-50 p-1 sm:self-auto">
            {filters.map((filter) => (
              <button
                key={filter}
                type="button"
                onClick={() => setActiveFilter(filter)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-xs transition-colors duration-200 md:text-sm ${
                  activeFilter === filter
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-100"
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        <div className="relative mt-12 pl-6 md:pl-0">
          <span className="absolute left-[7px] top-2 h-[calc(100%-1rem)] w-px bg-background-300 md:left-[92px]" />

          <ul className="flex flex-col gap-8">
            {visibleItems.map((item) => (
              <li key={item.id} className="relative flex flex-col gap-4 md:flex-row md:gap-8">
                <span className="hidden w-16 shrink-0 pt-1 text-right font-label text-xs text-foreground-500 md:block">
                  {item.time}
                </span>

                <span className="absolute -left-6 top-2 flex h-3.5 w-3.5 items-center justify-center md:left-[86px]">
                  <span className="h-3.5 w-3.5 rounded-full border-2 border-background-100 bg-accent-500" />
                </span>

                <div className="flex flex-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-300 hover:border-primary-200 md:p-5">
                  <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md md:h-24 md:w-32">
                    <img
                      src={item.cover}
                      alt={`${item.title}现场实拍缩略图`}
                      title={`私拍吃瓜 ${item.title}`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] text-accent-900">
                        {item.tag}
                      </span>
                      <span className="font-label text-[11px] text-foreground-500 md:hidden">
                        {item.time}
                      </span>
                    </div>
                    <h3 className="mt-2 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">
                      {item.excerpt}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {visibleItems.length === 0 && (
          <p className="mt-10 rounded-lg border border-dashed border-background-300 bg-background-50 py-12 text-center text-sm text-foreground-500">
            该类型暂无新的现场更新，换个分类看看。
          </p>
        )}

        <div className="mt-12 flex justify-center">
          <a
            href="#collections"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm text-foreground-800 transition-colors duration-200 hover:bg-background-200"
          >
            <i className="ri-stack-line text-base" />
            回到合集索引继续翻
          </a>
        </div>
      </div>
    </section>
  );
}